/* @flow */

import React, { Component } from 'react';
import { Menu, Button } from 'semantic-ui-react';
import PageSelector from 'catalog/screens/shared/components/PageSelector';

type Props = {
  onPageSelected: (page: CatalogPage) => void,
};

type State = {
  selectorVisible: boolean,
};

class LinksHeader extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectorVisible: false,
    };
  }

  showSelector = () => this.setState({ selectorVisible: true });
  hideSelector = () => this.setState({ selectorVisible: false });

  onPageSelected = (page: CatalogPage) => {
    this.hideSelector();
    this.props.onPageSelected(page);
  };

  render() {
    const { selectorVisible } = this.state;

    return (
      <Menu borderless attached="top">
        <Menu.Item header>Liaison(s)</Menu.Item>
        <Menu.Item position="right">
          <Button
            onClick={this.showSelector}
            content="Ajouter"
            floated="right"
            labelPosition="left"
            icon="plus"
            size="small"
          />
        </Menu.Item>
        <PageSelector
          visible={selectorVisible}
          onSelected={this.onPageSelected}
          onCancel={this.hideSelector}
        />
      </Menu>
    );
  }
}

export default LinksHeader;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/components/NavigationLinksHeader.js